import {InnerFilterValue, InnerFilters} from 'types';
import {RecallAuditEventType, RecallAuditFilters} from 'types/recall-audit';

const getValue = (value: InnerFilterValue | undefined) => {
    if (value && typeof value === 'object' && !Array.isArray(value) && 'value' in value) {
        return value.value;
    }
    return value;
};

const getTextValue = (value: InnerFilterValue | undefined) => {
    const resolvedValue = getValue(value);

    if (typeof resolvedValue !== 'string') return undefined;

    return resolvedValue.trim() || undefined;
};

export const mapRecallAuditFilters = (filters: InnerFilters): RecallAuditFilters => {
    const [from, to] = (filters.eventTimestamp as [Date | null, Date | null]) ?? [];
    const eventType = getValue(filters.eventType) as RecallAuditEventType | undefined;
    const userId = getValue(filters.userId);
    const userFullName = getTextValue(filters.userFullName);
    const organizationId = getValue(filters.organizationId);
    const organizationName = getTextValue(filters.organizationName);
    const organizationTin = getTextValue(filters.organizationTin);

    return {
        ...(userId && {userId: String(userId)}),
        ...(userFullName && {userFullName}),
        ...(organizationId && {organizationId: Number(organizationId)}),
        ...(organizationName && {organizationName}),
        ...(organizationTin && {organizationTin}),
        ...(eventType && {eventType}),
        ...(from && {from: from.toISOString()}),
        ...(to && {
            to: new Date(
                to.getFullYear(),
                to.getMonth(),
                to.getDate(),
                23,
                59,
                59,
                999,
            ).toISOString(),
        }),
        ...(filters.productCode && {productCode: String(filters.productCode)}),
        ...(filters.batchNumber && {batchNumber: String(filters.batchNumber)}),
        ...(filters.batchId && {batchId: Number(filters.batchId)}),
        ...(filters.reasonCode && {reasonCode: String(filters.reasonCode)}),
        ...(filters.regulatorDocumentNumber && {
            regulatorDocumentNumber: String(filters.regulatorDocumentNumber),
        }),
    };
};
